module.exports = __webpack_public_path__ + "img/marker_one_green2.7ba62fb3.png";